const COMBINING_DIACRITICS = /[̀-ͯ]/g
const NON_ALPHANUM = /[^a-z0-9]+/g
const EDGE_HYPHENS = /^-+|-+$/g

export function slugifyTitle(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(COMBINING_DIACRITICS, '')
    .replace(NON_ALPHANUM, '-')
    .replace(EDGE_HYPHENS, '')
}
